/* eslint-disable @harmony/stencil/no-tailwind-disable */
/* eslint-disable tailwindcss/no-custom-classname */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { useConfigService } from '@thd-nucleus/experience-context';
import { params, shape, string as stringType, QueryProvider } from '@thd-nucleus/data-sources';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import {
  containerWidthClass,
  FEATURE_SWITCH,
  ERROR_MESSAGES,
} from '../utils/consts';
import CheckBalanceForm from './check-balance/CheckBalanceForm';
import ReloadForm from './reload/ReloadForm';
import { getReCaptchaKey } from '../utils/utils';
import { AlertProvider } from '../context/alertContext';

const GiftCardsCheckBalanceAndReload = ({ isDrawer }) => {
  const [cardDetail, setCardDetail] = useState(null);
  const siteKey = getReCaptchaKey();
  const isReloadDisabled = !!useConfigService(FEATURE_SWITCH.DISABLE_GIFT_CARD_RELOAD);

  useEffect(() => {
    if (window && window.sessionStorage.getItem('reloadCheckout')) {
      window.sessionStorage.removeItem('reloadCheckout');
    }
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('gift-cards-check-balance-and-reload.ready');
  }, []);

  const handleBalanceFormSubmit = (cardInfo) => {
    const {
      __typename,
      cardNumber,
      availableAmount,
      holdAmount,
      originalAmount,
      reloadableAmount,
      error
    } = cardInfo;
    const parsedCardInfo = {
      __typename,
      cardNumber,
      availableAmount: parseFloat(availableAmount),
      holdAmount: parseFloat(holdAmount),
      originalAmount: parseFloat(originalAmount),
      reloadableAmount: parseFloat(reloadableAmount),
      error
    };
    setCardDetail(parsedCardInfo);
  };

  const handleCancel = () => {
    setCardDetail(null);
  };

  return (
    <QueryProvider
      cacheKey="gift-cards-check-balance-and-reload"
      defaultVariables={{
        itemId: '',
        dataSource: 'catalog'
      }}
    >
      <>
        <div
          className="g-recaptcha"
          data-sitekey={siteKey}
          data-size="invisible"
        />
        <div
          className="sui-w-full sui-h-full sui-flex sui-flex-col sui-items-center"
          data-component="GiftCardsCheckBalanceAndReload"
        >
          {!isDrawer && (
            <div
              className="sui-w-full sui-mb-8"
              data-testid="check-balance-title"
            >
              <Typography variant="h1" weight="bold" align="left">
                Check Balance and Reload
              </Typography>
            </div>
          )}
          <div
            className={
              isDrawer
                ? 'sui-w-full sui-h-full'
                : className('sui-max-w-full', containerWidthClass)
            }
          >
            <AlertProvider>
              <>
                {!cardDetail ? (
                  <CheckBalanceForm
                    onSubmit={handleBalanceFormSubmit}
                    isDrawer={isDrawer}
                  />
                ) : (
                  <>
                    {isReloadDisabled && (
                      <Alert
                        status="warning"
                        size="large"
                        data-testid="card-number-warning-message"
                        headline={ERROR_MESSAGES.DISABLE_GIFTCARD_RELOAD_HEADLINE}
                      >
                        {ERROR_MESSAGES.DISABLE_GIFTCARD_RELOAD_MESSAGE}
                      </Alert>
                    )}
                    <ReloadForm
                      cardNumber={cardDetail?.cardNumber}
                      reloadableAmount={cardDetail?.reloadableAmount}
                      availableAmount={parseFloat(cardDetail?.availableAmount)}
                      holdAmount={parseFloat(cardDetail?.holdAmount)}
                      cardError={cardDetail?.error}
                      onCancel={handleCancel}
                      isDrawer={isDrawer}
                      isReloadDisabled={isReloadDisabled}
                    />
                  </>
                )}
              </>
            </AlertProvider>
          </div>
        </div>
      </>
    </QueryProvider>
  );
};

GiftCardsCheckBalanceAndReload.displayName = 'GiftCardsCheckBalanceAndReload';
GiftCardsCheckBalanceAndReload.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSource: stringType(),
    identifiers: shape({
      productLabel: stringType()
    })
  })
};

GiftCardsCheckBalanceAndReload.propTypes = {
  isDrawer: PropTypes.bool
};
GiftCardsCheckBalanceAndReload.defaultProps = {
  isDrawer: false
};

export { GiftCardsCheckBalanceAndReload };
